module.exports = __webpack_public_path__ + "img/panda6.07192d5f.png";